// MessageCategoryFeedsById.js
'use strict';
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import withRouter from '../component/WithRouter.jsx';
import MessageCategoryFeedsById from '../page/MessageCategoryFeedsById.jsx';
import { replace } from '../action/navigationAction.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { getSiblingCategoryIds } from '../selector/getRemoteConfigComputedData.js';
import { MESSAGE_CATEGORY_TABS } from '../RemoteConfigKeys.js';

const mapStateToProps = (
  state,
  { match, categoryId: propsCategoryId, listType: propsListType }
) => {
  const deviceWidth = getOperationData(state, ['device'], 'width');
  const categoryGroups = getRemoteConfigData(state, MESSAGE_CATEGORY_TABS);
  const categoryId = propsCategoryId || match?.params?.categoryId;
  const listType =
    propsListType || match?.params?.listType || categoryGroups?.[0];

  return {
    deviceWidth,
    categoryTabs: categoryGroups,
    categoryId,
    listType,
    siblingCategoryIds: getSiblingCategoryIds(state, categoryId),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    replace: (...args) => dispatch(replace(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MessageCategoryFeedsById));
